import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { setUserHasAllowedToShareLocation } from '../../../actions/sharedActions';
import { ReactComponent as IconLocation } from '../../../icons/location.svg';
import Button from '../button';
import OpeningHoursTileLoader from './openingHoursTileLoader';

const StyledWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	max-width: 48rem;
	margin: 0 auto;
	padding: 3rem;
	font-size: 2rem;
	text-align: center;

	svg {
		width: 4.5rem;
		height: auto;
		margin-bottom: 3rem;

		path {
			fill: ${({ theme }) => theme.colors.textColor};
		}
	}
`;

const StyledButtonWrapper = styled.div`
	margin-top: 3rem;
`;

interface Props {
	children: any;
}

const LocationApprovalRequired: FC<Props> = ({ children }) => {
	const { t } = useTranslation('common');
	const dispatch = useDispatch<any>();
	const [locationFound, setLocationFound] = useState(false);
	const { userHasAllowedToShareLocation } = useSelector(({ sharedReducer }) => sharedReducer);

	const onGetLocation = () => {
		dispatch(setUserHasAllowedToShareLocation());
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(() => {});
		}
		navigator.geolocation.getCurrentPosition(
			() => {
				setLocationFound(true);
			},
			err => {
				console.log('Error fetchign lcoation', err);
			}
		);
	};

	return (
		<>
			{!userHasAllowedToShareLocation && (
				<StyledWrapper>
					<>
						{' '}
						<IconLocation />
						<div>{t('allow-location-text')}</div>
						<StyledButtonWrapper>
							<Button onClick={onGetLocation} primary>
								{t('allow-location')}
							</Button>
						</StyledButtonWrapper>
					</>
				</StyledWrapper>
			)}
			{userHasAllowedToShareLocation && locationFound && <>{children}</>}
			{userHasAllowedToShareLocation && !locationFound && (
				<div style={{ marginTop: '3rem' }}>
					<OpeningHoursTileLoader />
				</div>
			)}
		</>
	);
};

export default LocationApprovalRequired;
